"use strict";

exports.__esModule = true;
exports.shouldOpenPreferencesModal = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _types2 = require("@wix/ambassador-bookings-v2-bookings-settings/types");
var _location = require("../../domain/location/location");
const shouldOpenPreferencesModal = ({
  service,
  isDummy = false,
  isMultiServiceAppointmentEnabled,
  experiments,
  staffSelection,
  locationSelection
}) => {
  if (service.type !== _types.ServiceType.APPOINTMENT) {
    return false;
  }
  const hasMultiServiceAppointments = !isDummy && isMultiServiceAppointmentEnabled;
  const hasDynamicDuration = hasServiceDynamicDuration(service);
  const hasAddOns = hasServiceAddOns(service, experiments);
  const hasStaffMemberBeforeSelection = hasStaffMemberBefore(service, staffSelection);
  const hasLocationBeforeSelection = hasLocationBefore(service, locationSelection);
  return hasMultiServiceAppointments || hasDynamicDuration || hasAddOns || hasStaffMemberBeforeSelection || hasLocationBeforeSelection;
};
exports.shouldOpenPreferencesModal = shouldOpenPreferencesModal;
const hasServiceAddOns = (service, experiments) => {
  var _service$addOnGroups;
  return experiments.enabled('specs.bookings.AddonsUOU') && !!((_service$addOnGroups = service.addOnGroups) != null && _service$addOnGroups.some(group => {
    var _group$addOnIds;
    return (_group$addOnIds = group.addOnIds) == null ? void 0 : _group$addOnIds.length;
  }));
};
const hasServiceDynamicDuration = service => {
  var _service$schedule;
  const durations = ((_service$schedule = service.schedule) == null || (_service$schedule = _service$schedule.availabilityConstraints) == null ? void 0 : _service$schedule.durations) || [];
  return durations.length > 1;
};
const hasStaffMemberBefore = (service, staffSelection) => {
  var _service$staffMembers;
  const hasMultipleStaffMembers = (((_service$staffMembers = service.staffMembers) == null ? void 0 : _service$staffMembers.length) || 0) > 1;
  const hasCorrectTiming = (staffSelection == null ? void 0 : staffSelection.timing) === _types2.StaffSelectionTiming.BEFORE_SLOT_SELECTION;
  const customerCanChoose = (staffSelection == null ? void 0 : staffSelection.strategy) !== _types2.Strategy.CUSTOMER_CANNOT_CHOOSE;
  return hasMultipleStaffMembers && hasCorrectTiming && customerCanChoose;
};
const hasLocationBefore = (service, locationSelection) => {
  const businessLocations = (0, _location.filterNonBusinessLocations)(service.locations || []);
  const hasMultipleLocations = businessLocations.length > 1;
  const hasCorrectTiming = (locationSelection == null ? void 0 : locationSelection.timing) === _types2.Timing.BEFORE_SLOT_SELECTION;
  return hasMultipleLocations && hasCorrectTiming;
};
//# sourceMappingURL=shouldOpenPreferencesModal.js.map